import { render, staticRenderFns } from "./QrBase.vue?vue&type=template&id=2803a90f&scoped=true&"
import script from "./QrBase.vue?vue&type=script&lang=js&"
export * from "./QrBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2803a90f",
  null
  
)

export default component.exports